import { css, CSSResult } from 'lit'


export const style: CSSResult = css`
  .cse-group {
    display: flex;
  }

  .inline {
    display: inline-flex;
  }

  .cse-group:not(.no-wrap) {
    flex-wrap: wrap;
  }

  /* .direction-row-reverse {
    flex-direction: row-reverse;
  }

  .direction-column {
    flex-direction: column;
  }

  .direction-column-reverse {
    flex-direction: column-reverse;
  }

  .justify-space-between {
    justify-content: space-between;
  }

  .justify-space-evenly {
    justify-content: space-evenly;
  }

  .justify-start {
    justify-content: start;
  }

  .justify-center {
    justify-content: center;
  }

  .justify-end {
    justify-content: end;
  }

  .align-center {
    align-items: center;
  } */
`
